const Product = [
    {
      id: '1',
      department:"New Arrival",
      name: 'Cantilever chair',
      code:"Code - Y523201",
      image:'/image/ch2.png',
        price:"$42.00" ,
    oldprice:"$65.00"
          },
   {
      id: '2',
      department:"New Arrival",
      name: 'Cantilever chair',
      code:"Code - Y523201",
      image:'/image/ch3.png',
        price:"$42.00" ,
    oldprice:"$65.00"
         },
    {
      id: '3',
      department:"New Arrival",
      name: 'Cantilever chair',
      code:"Code - Y523201",
      image:'/image/ch13.png',
        price:"$42.00" ,
    oldprice:"$65.00"
                      },
    {
      id: '4',
      department:"New Arrival",
      name: 'Cantilever chair',
      code:"Code - Y523201",
      image:'/image/ch4.png',
        price:"$42.00" ,
    oldprice:"$65.00"
      },
      {
        id: '5',
        department:"New Arrival",
        name: 'Cantilever chair',
        code:"Code - Y523201",
        image:'/image/ch5.png',
          price:"$42.00" ,
      oldprice:"$65.00"
       
        },

        {
          id: '6',
          department:"New Arrival",
          name: 'Cantilever chair',
          code:"Code - Y523201",
          image:'/image/ch13.png',
            price:"$42.00" ,
        oldprice:"$65.00"
         
          },
          {
            id: '7',
            department:"Best Seller",
            name: 'Cantilever chair',
            code:"Code - Y523201",
            image:'/image/ch7.png',
              price:"$42.00" ,
          oldprice:"$65.00"
           
            },
            {
              id: '8',
              department:"Best Seller",
              name: 'Cantilever chair',
              code:"Code - Y523201",
              image:'/image/ch8.png',
                price:"$42.00" ,
            oldprice:"$65.00"
             
              },

              {
                id: '9',
                department:"Best Seller",
                name: 'Cantilever chair',
                code:"Code - Y523201",
                image:'/image/ch9.png',
                  price:"$42.00" ,
              oldprice:"$65.00"
                },

                {
                  id: '10',
                  department:"Featured",
                  name: 'Cantilever chair',
                  code:"Code - Y523201",
                  image:'/image/ch10.png',
                    price:"$42.00" ,
                oldprice:"$65.00"
                 
                  },
 {
      id: '11',
      department:"Featured",
      name: 'Cantilever chair',
      code:"Code - Y523201",
      image:'/image/ch11.png',
        price:"$42.00" ,
    oldprice:"$65.00"
     
      },
      {
        id: '12',
        department:"",
      name: 'Cantilever chair',
      code:"Code - Y523201",
      image:'/image/ch12.png',
        price:"$42.00" ,
    oldprice:"$65.00"
       
        },

        {
          id: '13',
          department:"Special Offer",
          name: 'Cantilever chair',
          code:"Code - Y523201",
          image:'/image/ch13.png',
            price:"$42.00" ,
        oldprice:"$65.00"
         
          },

          {
            id: '14',
            department:"Special Offer",
            name: 'Cantilever chair',
            code:"Code - Y523201",
            image:'/image/ch2.png',
              price:"$42.00" ,
          oldprice:"$65.00"
           
            },

            {
              id: '15',
              department:"Special Offer",
              name: 'Cantilever chair',
              code:"Code - Y523201",
              image:'/image/ch4.png',
                price:"$42.00" ,
            oldprice:"$65.00"
             
              },

             

  ];
  
  export default Product;